import lookup from "../framework/utils/lookup";

const codes = {
  deposit: 1,
  authorization: 2,
  post: 3,
  claim: 4,
  refund: 5,
  cancelledAuthorization: 9,
  expiredAuthorization: 10,
  declinedAuthorization: 16,
  refundExpiredAuthorization: 28
};

const transactionUtils = {
  codes: codes,
  isAuthorization(transaction) {
    const authCodes = [codes.authorization, codes.declinedAuthorization, codes.expiredAuthorization, codes.refundExpiredAuthorization];
    return authCodes.includes(transaction.transactionCode);
  },
  getDisplayAmount(transaction) {
    if (transaction.transactionCode == codes.declinedAuthorization || (!transaction.amount && transaction.deniedAmount)) return transaction.deniedAmount;
    return transaction.amount;
  },
  getPositiveDisplayAmount(transaction) {
    var am = this.getDisplayAmount(transaction);
    return am >= 0 ? am : null;
  },
  getNegativeDisplayAmount(transaction) {
    var am = this.getDisplayAmount(transaction);
    return am < 0 ? am : null;
  },
  getAdjudicationStatus(transaction) {
    if(transaction.adjudicationStatus == 100) return '';
    return lookup("AdjudicationStatus").value(transaction.adjudicationStatus);
  },
  getTransactionCode(transaction) {
    if(transaction.wcaRawData && transaction.wcaRawData.hsaCodeDescription == "CY Normal Contribution – Employer") {
      return "Deposit";
    }
    let code = lookup("Transactions.TransactionCode").value(transaction.transactionCode);
    if ((code == 'Post' || code == 'Authorization') && transaction.amount > 0) return "Refund";
    return code == 'Post' || code == 'Authorization' ? "Card" : code;
  },
  showDeniedAmount(transaction) {
    return transaction.amount && transaction.deniedAmount && Math.abs(transaction.deniedAmount) > 0;  
  },
  isAuthPostOrClaim(transaction) {
    return [codes.authorization, codes.post, codes.claim].includes(transaction.transactionCode);
  },
  isClaim(transaction) {
    return transaction.transactionCode == 4;
  }
}

export default transactionUtils;



// WEBPACK FOOTER //
// ./src/transactions/transaction-utils.js